import { useTranslation } from 'react-i18next';
import { ListPageLayout } from '@/components/templates';
import { ProductListContainer } from '@/features/products/containers/product-list-container';

export default function ProductsPage() {
  const { t } = useTranslation();

  return (
    <ListPageLayout title={t('products.title')}>
      <ProductListContainer />
    </ListPageLayout>
  );
}
